var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormatVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E36A6",
  fillRule: "evenodd",
  d: "M2 19a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM3 5v14h18V5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E36A6",
  d: "m10.5 10.208 3.727 2.16-3.727 2.16zm-1.273-2.34v9l7-4.5z"
})));
export default SvgFormatVideo;